module.exports = __webpack_public_path__ + "img/location.1d9f34d2.svg";